<template>
  <div class="ChildsCoalition">
    <top-component></top-component>
    <div class="Coalition-title">
      <div class="Coalition-title-font">联合体专区</div>
    </div>
    <div class="Coalition-content">
      <div class="Coalition-contentFor" v-for="(item, index) in dataAll" :key="index">
        <div class="Coalition-contentFor-title">{{item.title}}</div>
        <div class="Coalition-contentFor-content" v-for="(item1, index) in item.child" :key="index"
          @click="placeClick(item1)">
          &emsp;{{item1.publisher}}
        </div>
      </div>
      <!-- <div class="Coalition-contentFor">
        <div class="Coalition-contentFor-title">{{this.$route.params.areaName}}</div>
        <div class="Coalition-contentFor-content" v-for="(item, index) in childrens" :key="index"
          @click="placeClick(item)">
          &emsp;{{item.publisher}}
        </div>
      </div> -->
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { searchpageCity } from '@/api/img'
  import { exhibitionPublisherlist, actionlistAll } from '@/api/pages'
  import Cookies from 'js-cookie'
  export default {
    name: 'PublisherChildsPlaces',
    data() {
      return {
        dataAll: [],
        childrens: []
      }
    },
    mounted() {
    //   console.log(this.$route.params.areaName)
      // this.DiFangDataList()
      this.AllDiFangDataList()
    },
    methods: {
      // 地方版出版社-获取子列表
      DiFangDataList() {
        var obj = {
          unionName: this.$route.params.areaName
        }
        exhibitionPublisherlist(obj).then(response => {
        //   console.log(response)
          this.childrens = response.data
        })
      },
      // 地方版出版社-获取子列表
      AllDiFangDataList() {
        actionlistAll().then(response => {
        //   console.log(response)
          this.dataAll = response.data
        })
      },
      // 跳转到具体的商品列表
      placeClick(item) {
        // console.log(item)
        this.$router.push({ name: 'supplierdetails', query:{obj: JSON.stringify({ gid: item.unionGid, goodsType: 1 ,publisherId: item.publisherId,pubname2:item.publisher})}})
        // Cookies.set('gid', item.unionGid)
        // Cookies.set('goodsType', 1)
      }
    },
    components: {
      BottomComponent,
      TopComponent
    }
  }
</script>

<style scoped lang="scss">
  .ChildsCoalition {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* 1 */
  .Coalition-title {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .Coalition-title-font {
    width: 1180px;
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: calc(50% - 590px);
    color: rgba(0, 0, 0, 1);
    font-size: 24px;
    font-weight: 600;
  }

  /* 2 */
  .Coalition-content {
    width: 1180px;
    /* height: 500px; */
    margin-left: calc(50% - 590px);
  }

  .Coalition-contentFor {
    margin-top: 20px;
  }

  .Coalition-contentFor-title {
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    margin-left: 5px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .Coalition-contentFor-content {
    width: 285px;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    border-radius: 4px;
    margin-left: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    margin-top: 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 13px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Publisher-ChildsCoalition.vue